import { SingletonRouter } from "next/router";
import { LinkProps } from "next/link";
import React from "react";
import { router as linkRouter } from "../../../../routes";

const { Link } = linkRouter;

export const linkBuilder = (router: SingletonRouter | undefined) => (page: number) => {
  const LinkComponent: React.FC<LinkProps> = ({ children }) => (
    <Link
      route="filters"
      params={Object.assign({}, router ? router.query : {}, { page })}
      passHref={true}
      shallow={true}
    >
      {children}
    </Link>
  );
  return LinkComponent;
};
